(ns renolit-roofing-service.layout.form.form-item.search
  (:require [goog.object :as g]
            [reagent.core :as r]
            [renolit-roofing-service.layout.form.form-item :as form.form-item]
            [renolit-roofing-service.layout.icon :as layout.icon]
            [renolit-roofing-service.localization :refer [t]]
            [renolit-roofing-service.util :as util]))

(defmethod form.form-item/form-item-component :search
  [_opts]
  (let [component-id (str (random-uuid))
        temp-value (r/atom nil)]
    (fn [{:keys [state path on-type on-change
                 css-class-prefix placeholder-transl-kw]}]
      (let [on-submit-fn
            (fn [& _]
              (util/execute-callback on-change @temp-value))
            value (when state (get-in @state path))]
        [:div.form-item.form-item--search
         {:class (when css-class-prefix css-class-prefix)}
         [:button.flat-btn.form-item__search-btn
          {:type "button"
           :on-click on-submit-fn
           :class (when css-class-prefix
                    (str css-class-prefix "__button"))}
          [layout.icon/icon
           {:key :search}]]
         [:input.form-item__search-input
          (cond->
           {:type "text"
            :id component-id
            :value (or @temp-value value)
            :on-key-down
            (fn [e]
              (when (= (g/getValueByKeys e "key") "Enter")
                (on-submit-fn)))
            :on-change
            (fn [e]
              (let [new-value (g/getValueByKeys e "target" "value")]
                (reset! temp-value new-value)
                (util/execute-callback on-type @temp-value)))}

            placeholder-transl-kw
            (assoc :placeholder (t [placeholder-transl-kw]))

            css-class-prefix
            (assoc :class (str css-class-prefix "__input")))]]))))
